import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Expenses, Expense, StoreApplicant } from '@funnels/types';

export default function cloneGroupedExpenseComments(
  expenses: Expenses[],
  applicantsGroups: StoreApplicant[][]
): Expenses[] {
  const clonedCommentExpenses: Expenses[] = [];
  applicantsGroups.forEach((applicantGroup) => {
    const [mainApplicant, secondApplicant] = applicantGroup;
    const mainApplicantExpenses = expenses.find((expense) => expense.applicantId === mainApplicant?.id);
    const secondApplicantExpenses = expenses.find((expense) => expense.applicantId === secondApplicant?.id);
    const commentToCopy = get({ expenses: [mainApplicantExpenses] }, FIELD_PATHS.EXPENSES_EXPENSE_COMMENTS(0, 0));

    [mainApplicantExpenses, secondApplicantExpenses].forEach((applicantExpenses) => {
      // if for some reason the paired applicant doesnt have expenses back out
      if (!applicantExpenses) {
        return;
      }
      const updatedExpenses: Expense[] =
        applicantExpenses?.expenses.map((expense) => {
          return { ...expense, comments: commentToCopy };
        }) || [];
      clonedCommentExpenses.push({ ...applicantExpenses, expenses: updatedExpenses } as Expenses);
    });
  });
  return clonedCommentExpenses;
}
